export default "https://cdn-static.gokick.com/assets/94c0a6f1f1290e979b6f5177b757303844c3d722/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";